/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import { ClosureInfo, DetailPanel } from "components/EditTraffic/DetailPanel";
import { useMapDataContext } from "context/MapDataProvider";
import moment from "moment";

export interface RoadClosureDetailProps {
  start: google.maps.LatLngLiteral;
  end: google.maps.LatLngLiteral;
}

export const RoadClosureDetail: FC<RoadClosureDetailProps> = ({
  start,
  end,
}) => {
  const { mapData } = useMapDataContext();
  const position = {
    lat: (start.lat + end.lat) / 2,
    lng: (start.lng + end.lng) / 2,
  };
  const unixTime = mapData.updatedAt ?? mapData.createdAt;
  const closure: ClosureInfo = {
    position: position,
    isNew: false,
    inputUser: mapData.updateUser,
    inputDate: unixTime ? moment(unixTime).toDate() : undefined,
  };
  return <DetailPanel closure={closure} editable={false} saveEnable={false} />;
};
